import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Phone, Mail, MapPin, Loader2 } from "lucide-react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/leads", form);
      toast.success("Thanks — we'll be in touch within 1 business hour.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch { toast.error("Could not send. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div className="container-x py-20 md:py-28" data-testid="contact-page">
      <div className="grid md:grid-cols-2 gap-16">
        <div>
          <div className="overline mb-4">Contact</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tight text-[#111]">Let's talk about your space.</h1>
          <p className="mt-5 text-[#4A554E] text-lg max-w-md">Fill the form or call us directly. We respond to every inquiry within 1 business hour.</p>
          <div className="mt-10 space-y-4">
            <a href="tel:9432450462" className="flex items-center gap-4 text-[#111] hover:text-[#0B5D3B]" data-testid="contact-phone">
              <div className="w-10 h-10 rounded-full bg-[#0B5D3B]/10 flex items-center justify-center"><Phone className="w-4 h-4 text-[#0B5D3B]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[#7A8A81]">Phone</div>
                <div className="font-medium">943-245-0462</div>
              </div>
            </a>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-[#0B5D3B]/10 flex items-center justify-center"><Mail className="w-4 h-4 text-[#0B5D3B]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[#7A8A81]">Email</div>
                <div className="font-medium">shonicscleaningsolutions@gmail.com</div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-[#0B5D3B]/10 flex items-center justify-center"><MapPin className="w-4 h-4 text-[#0B5D3B]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[#7A8A81]">Service area</div>
                <div className="font-medium">Metro Atlanta, GA · 8 cities</div>
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="card-luxe p-8 md:p-10" data-testid="contact-form">
          <h2 className="font-serif text-2xl mb-6">Send us a message</h2>
          {[
            { k: "name", label: "Name", type: "text", required: true },
            { k: "email", label: "Email", type: "email", required: true },
            { k: "phone", label: "Phone", type: "tel", required: false },
          ].map((f) => (
            <React.Fragment key={f.k}>
              <label className="overline">{f.label}</label>
              <input type={f.type} required={f.required} value={form[f.k]}
                onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
                className="w-full px-5 py-3.5 mt-2 mb-5 rounded-full border border-[#EAE3D2] focus:border-[#0B5D3B] focus:outline-none"
                data-testid={`contact-${f.k}`} />
            </React.Fragment>
          ))}
          <label className="overline">Message</label>
          <textarea rows={4} required value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="w-full px-5 py-3 mt-2 mb-7 rounded-2xl border border-[#EAE3D2] focus:border-[#0B5D3B] focus:outline-none"
            data-testid="contact-message" />
          <button disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="contact-submit">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Sending…</> : "Send message"}
          </button>
        </form>
      </div>
    </div>
  );
}
